import type {FC} from 'react'
import {displayFormat, fullNameFormat} from 'libs/formatter'
import {AttachmentsProps} from './ApplyFormDetail'
import {AttachmentItem} from '../AttachmentItem'

// @ts-ignore
import ListGroup from 'jbc-front/components/ListGroup'

export const Attachments: FC<AttachmentsProps> = ({egovProcedure}) => {
  const employee = egovProcedure.procedureStatus?.employee
  const name = fullNameFormat(employee?.displayLastName, employee?.displayFirstName)

  return (
    <>
      <ListGroup>
        <ListGroup.Title>手続き名称</ListGroup.Title>
        <ListGroup.Item>{egovProcedure.formName}</ListGroup.Item>
      </ListGroup>
      <ListGroup>
        <ListGroup.Title>対象従業員</ListGroup.Title>
        <ListGroup.Item>{name}</ListGroup.Item>
      </ListGroup>
      <ListGroup>
        <ListGroup.Title>添付書類</ListGroup.Title>
        {egovProcedure.attachments.length > 0 ? (
          egovProcedure.attachments.map((attachment, i) => (
            <ListGroup.Item key={`attachment-key-${i}`}>
              <AttachmentItem egovProcedure={egovProcedure} attachment={attachment} />
            </ListGroup.Item>
          ))
        ) : (
          <ListGroup.Item>{displayFormat()}</ListGroup.Item>
        )}
      </ListGroup>
    </>
  )
}
